import { FC, useEffect, useMemo } from 'react'
import maplibregl, { Map, Marker, LngLatBounds } from 'maplibre-gl'
import { AddressFile } from './types'

interface LocationMarkersProps {
  map?: Map,
  pickupAddress: AddressFile,
  dropoffAddress: AddressFile
}

const updateMarker = (marker: Marker, address: any, bounds: LngLatBounds) => {
  const markerElement = marker.getElement()
  if (address.lon && address.lat) {
    marker.setLngLat([address.lon, address.lat])
    bounds.extend([address.lon, address.lat])
    markerElement.style.visibility = 'visible'
  } else {
    markerElement.style.visibility = 'hidden'
  }
}

const createMarker = (map: Map | undefined, color: string): Marker => (
  new maplibregl.Marker({ color })
    .setLngLat([0, 0])
    .addTo(map as Map)
)

const LocationMarkers: FC<LocationMarkersProps> = ({ map, pickupAddress, dropoffAddress }) => {
  const pickupMarker = useMemo(() => createMarker(map, '#007FFF'), [])
  const dropoffMarker = useMemo(() => createMarker(map, '#1AA251'), [])
  useEffect(() => {
    const bounds = new maplibregl.LngLatBounds()
    updateMarker(pickupMarker, pickupAddress, bounds)
    updateMarker(dropoffMarker, dropoffAddress, bounds)

    if (!bounds.isEmpty()) {
      map?.fitBounds(bounds, {
        padding: 100,
        maxZoom: 15
      })
    }
  }, [pickupAddress, dropoffAddress])

  return null
}

export default LocationMarkers
